import Audio from './Audio';
import AdaptrFeedFm from './AdaptrFeedFm';
import Video from './Video';
import WaveSurfer from './WaveSurfer';

export type TMedia = Audio | AdaptrFeedFm | Video | WaveSurfer;

class MediaList {
  private stack: TMedia[] = [];

  public add = (target: TMedia): void => {
    this.stack.push(target);
  };

  public remove = (target: TMedia): void => {
    const deleteIndex: number = this.stack.findIndex((item) => item === target);
    if (!deleteIndex) {
      return;
    }
    this.stack.splice(deleteIndex, 1);
  };

  public exists = (target: TMedia): boolean => {
    return Boolean(this.stack.find((item) => item === target));
  };

  public take = (filter?: (item: TMedia) => boolean): TMedia[] => {
    if (filter) {
      return this.stack.filter(filter);
    }
    return this.stack;
  };
}

export default MediaList;
